module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-14"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-14"
    }
  }, [_vm._v("CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" open the front door to find Mom standing on the other side, trying to get her key in the lock. She glances up, looking like a mess in one of the shapeless shirts she usually wears just around the house. Her eyes look sad even though she’s laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is wrong with you?” I ask. I could hear her banging around from the kitchen, where I was trying to memorize my lines. She’s been acting off all week—but just because something is clearly going wrong at work doesn’t mean we should have to suffer at home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You saved my life,” Mom slurs as she falls inside, throwing her arms around me. Her weight is heavy on my shoulders and she reeks of beer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you drunk?” I shrug her off me and she stumbles back, giggling as she balances herself against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe just a little?” she whispers loudly, as if she just noticed we’re standing outside Dad’s closed office door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("“You’re wasted.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugs and stumbles past me, heading toward the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I follow a few steps behind, a little worried she might fall. If she does, I’ll have to break the one rule I’ve never broken and interrupt Dad when he’s counseling one of his online patients. But it’ll be her fault—she is not a small woman and I doubt I’d be able to pick her up on my own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Careful,” I say as she falls into her chair at the kitchen table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What kind of mother comes home out-of-her-mind drunk before it’s even dark outside? I glance at the clock on the microwave—it’s 4:35. Thank god Dad will be out of his session soon. She’s his responsibility, not mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can do this; I’ll be fine on my own.” Mom’s slurring her words together so I don’t fully understand. “The two of us, we’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about?” I ask, sounding more like the parent than the child, which is totally screwed up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She rests her head on her hands and hiccups. “Water.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I get a glass from the cabinet and fill it with the cold filtered water from the fridge and set it down in front of her. She hiccups again. “Thank you,” she says before taking a sip. “You love me, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not when you’re like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom closes her eyes and nods. I almost feel bad for a second that I may have hurt her feelings, but this is not how a mother is supposed to act.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t drive home, did you?” I ask, fully assuming the role of parent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uber,” she says, hiccuping again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At least she was semismart about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her glass is almost empty, so I fill it up again. When I turn "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("back, her eyes are fluttering closed like she’s about to fall asleep—right there at the kitchen table where we eat dinner, where I do my homework, where I’m supposed to be memorizing lines for a play she clearly doesn’t care about.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should go to bed,” I tell her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She mumbles in agreement, so I grab her arm and attempt to pull her up. She resists, but I’m younger, I’m stronger, and I’m sober.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I take a step back and steady myself, giving her arm a big yank. She finally stands up and drapes her arm around my shoulder. The two of us walk slow and steady like we’re tied together in a three-legged race. We’re rounding the corner of the living room toward the stairs when the door to Dad’s office flies open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What in the world?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, baby.” Mom lifts her head up, but it wobbles around like her neck isn’t really supporting it. “Everything’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got this,” Dad says, taking over just as Mom lets out a disgusting man-size belch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gross.” I step away and brush her germs off my shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad lifts her up, holding her like a baby in his arms. A big, drunk baby. It looks like it’s taking a lot of effort to carry her up the stairs, so I stay at the bottom in case he needs help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t leave me,” I hear Mom say before he turns into their room. The door closes, but I can still hear the sound of her crying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s a weird feeling in the pit of my stomach, and for a second, I’m scared that something is really wrong. Mom’s never done anything like this before. I try to think back to all the incoherent things she was mumbling about. Then all of a sudden, it’s so obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("I smile and head back into the kitchen. Maybe wishes do come true. Because I heard her, clear as day. She said, “Don’t leave me.” There’s no other explanation—Mom and Dad are getting a divorce. Or breaking up, since they aren’t officially married.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now I just have to decide how I’m going to let all this play out. If I let Dad know that I know, I could catch him off guard. Which could be good. Or it might make him mad. And if he’s mad, then I won’t be able to take full advantage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Sofia’s parents told her they were getting divorced, she practically had a meltdown. She locked herself in her room until her dad promised to put his credit card on an Uber account so she could go back and forth between their houses whenever she wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lauren got her mom to take her on a trip to Paris. I don’t remember how she pulled it off, something about being worried that she and her mom wouldn’t be as close since they weren’t going to be living in the same house all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Come to think about it, not having to live in a house with my mom would be even better than a trip to Paris. I could tell the judge how Mom came home drunk today. The courts would never leave an innocent child with a woman who did that sort of thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hear Dad’s cough getting closer, so I push my script aside and get him a glass of water—no time like the present to show him things will be okay when it’s just the two of us. I can help take care of him, probably better than Mom does. She’s so focused on her stupid agency, it’s like her employees mean more to her than we do. She’ll have plenty of time to spend with them once Dad and I move out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On second thought, Mom should be the one to move out. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("She can get an apartment and Dad and I can stay at the house. It makes more sense since his office is here, and so is all my stuff.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa, careful.” Dad reaches over my shoulder to turn off the faucet. The water is overflowing, pouring out of the glass like the fountain at Piedmont Park.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry, I was distracted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Understandable,” he says, before coughing again. I hand him the glass of water and he gives me a sad smile before taking a sip. “That must have been scary, seeing your mom like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever.” I shrug it off, remembering too late that I was supposed to make it seem like a bigger deal so I’m not lying when I tell the divorce judge about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mom’s got a lot going on,” he says, making excuses for her like he always does. Sometimes I wonder what he sees in her. At least he’s finally come to his senses; we’ll be better off without her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I lift myself up on the counter and watch as he tries to act normal and pretend nothing is wrong. I know I decided not to steal his thunder and let him break the news, but I don’t think I can wait. And with Mom being passed out drunk upstairs, there might not be a better time to go in for the full-custody kill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” I tell him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you know?” Dad asks, raising an eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know what’s going on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad takes a step back and sits down at the kitchen table. He looks tired and sad. “Oh, kiddo,” he says. “I wanted to be the one to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s okay,” I say, trying to keep my voice upbeat. “I al"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("ready told you—most of my friends’ parents are divorced. As long as you can get full custody, it’ll be fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Full custody?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or whatever it’s called. Mom can move out and you and I can stay here.” Dad takes a deep breath, which starts him coughing again. I hop off the counter and bring him the glass of water he left by the sink. “You’ve said it yourself: I’m grown-up for my age. I can help take care of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, Cecelia,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, yeah. I’m breaking your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sit down with me.” He reaches for my hand and pulls me closer until I’m sitting in his lap, the way I used to when I was little. “Your mom and I aren’t getting divorced.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you’re not officially married.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My stomach feels weird, the way it does for a second right before I go onstage. I stand up and turn around so I can look him in the face. “But I heard her. Mom said, ‘Don’t leave me.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She did,” Dad says, his voice eerily quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you going?” I pull my chair out and sit down so our knees are almost touching. “Daddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He reaches over and takes my hands in his. They’re shaking, and so is his right leg. “I’m sick, baby girl.” He coughs again as if he’s making a point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you’ll get better,” I tell him. “You’ll go to the doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looks down at the floor and squeezes my hands. When he looks back up, I can see the truth in his eyes, shining with tears that are about to fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve never seen my dad cry before. I don’t want to see him cry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to go.” My legs wobble beneath me as I stand up. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("I take a careful step, like I’m made of glass and the smallest wrong move could shatter me into a million tiny pieces that he’ll never be able to put back together. “I should go check on Mom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I keep walking out of the room, away from his sad eyes. He doesn’t stop me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upstairs, I close the door and collapse on my bed. The tears start falling before my head even hits the pillow. My shoulders start to shake and a loud noise comes out of my mouth that I’ve never heard before. My heart is racing, my stomach aches, and my breath is fogging up my glasses, but I don’t care enough to wipe them off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t hear my door open, but I feel the bed shift as Dad sits down beside me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s okay,” he lies. “It’s going to be okay.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30db6cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062934864_Chapter_7.vue
// module id = 87
// module chunks = 0